export default __webpack_public_path__ + "static/media/overdueTasksIconColored.9545026d.svg";